import { render } from "./UITabs.vue?vue&type=template&id=1c32d812&scoped=true"
import script from "./UITabs.vue?vue&type=script&lang=js"
export * from "./UITabs.vue?vue&type=script&lang=js"

import "./UITabs.vue?vue&type=style&index=0&id=1c32d812&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c32d812"]])

export default __exports__